export enum AppLanguage {
  English = 'en',
  HongKong = 'hk',
  China = 'cn',
  Japan = 'jp',
  Korea = 'kr',
}

const HOTEL_IDS = {
  bauhinia: '6837ba462d77609ce3c5b8f0',
  hourbourGrandKowloon: '69118b7ffd55308c976c4b5c',
  hourbourPlazaMetropolis: '69118b93fd55308c976c4b5e',
  kowloonHotel: '69118b9afd55308c976c4b60',
};

export const specialLanguageHotelMapping = {
  [HOTEL_IDS.bauhinia]: [
    AppLanguage.English,
    AppLanguage.HongKong,
    AppLanguage.China,
  ],
  [HOTEL_IDS.hourbourGrandKowloon]: [
    AppLanguage.English,
    AppLanguage.HongKong,
    AppLanguage.China,
    AppLanguage.Japan,
  ],
  [HOTEL_IDS.hourbourPlazaMetropolis]: [
    AppLanguage.English,
    AppLanguage.HongKong,
    AppLanguage.China,
    AppLanguage.Japan,
  ],
  [HOTEL_IDS.kowloonHotel]: [
    AppLanguage.English,
    AppLanguage.HongKong,
    AppLanguage.China,
    AppLanguage.Japan,
  ],
};
